<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title"> Installed </v-toolbar-title>
                </div>
                <div class="ml-auto d-flex">
                  <v-btn color="primary" class="ml-2" :disabled="!exportData.length">
                    <download-csv :data="exportData" :name="`${fileName}.csv`">
                      <v-icon dense>mdi-download</v-icon>
                      Export
                    </download-csv>
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search Reference Number, Account Number, Jo No, Name"
              single-line
              hide-details
              @click:append="searchRecord"
              @keydown.enter.prevent="searchRecord"
              @click:clear="getList()"
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :page="table.page"
            :pageCount="table.numberOfPages"
            :options.sync="options"
            :server-items-length="table.total"
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="_id"
            loading-text="Loading... Please wait"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [10, 20, 50, 100],
            }"
            dense
          >
            <!-- <template slot="body.append">
              <tr>
                <th>Total</th>
                <th class="text-center">
                  {{ setToLocaleString(getTotal(table.data), 0) }}
                </th>
              </tr>
            </template> -->
            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>

            <template v-slot:[`item.customer`]="{ item }">
              <a href="#" @click.prevent="showDetails(item)">{{ item.customer }}</a>
            </template>

            <template v-slot:[`item.dateApplied`]="{ item }">
              {{ item.createdDate }}
            </template>

            <template v-slot:[`item.duration`]="{ item }">
              {{ duration(item.createdDate, item.activationDate) }}
            </template>

            <template v-slot:[`item.affiliate`]="{ item }">
              <template v-if="item.affiliate && Object.keys(item.affiliate).length !== 0">
                {{ `${item.affiliate.firstname} ${item.affiliate.lastname}` }}
                - {{ item.affiliate.msisdn }}
              </template>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <online-application-dialog ref="onlineAppDialog"></online-application-dialog>
  </v-container>
</template>

<script>
import ShareableMethods from "@/mixins/ShareableMethods";
import OnlineApplicationDialog from "../dialogs/acquisition/OnlineApplicationDialog.vue";
import moment from "moment";
export default {
  mixins: [ShareableMethods],
  name: "OnlinePastDue",
  components: { OnlineApplicationDialog },
  data() {
    return {
      exportData: [],
      fileName: "",

      search: "",
      table: {
        page: 0,
        total: 0,
        numberOfPages: 0,

        expanded: [],
        singleExpand: false,
        sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        headers: [
          { text: "Customer", value: "customer" },
          { text: "Distributor", value: "codDistributor.name" },
          { text: "Reference Number", value: "referenceNumber" },
          // { text: "Mobile Number", value: "mobileNumber" },
          // { text: "Affiliator Details", value: "affiliate" },
          { text: "Barangay", value: "barangay" },
          { text: "City", value: "city" },
          { text: "Province", value: "province" },
          {
            text: "Date Applied",
            value: "createdDate",
            formatter: (x) => (x ? this.formatDate(x, "MMM DD, YYYY hh:ss A") : null),
          },
          // {
          //   text: "Preferred Date/Time",
          //   value: "installationDate",
          //   formatter: (x) =>
          //     x ? this.formatDate(x, "ddd MMM. DD, YYYY HH:ss A") : null,
          // },
          {
            text: "Activation Date",
            value: "activationDate",
            formatter: (x) => (x ? this.formatDate(x) : null),
          },
          {
            text: "Duration",
            value: "duration",
          },
        ],
        data: [],
      },
      options: {
        page: 1,
      },
    };
  },
  props: {
    distributorId: {
      type: String,
      default: "",
    },
    isDistributor: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    async getList(searchVal = "") {
      this.table.loading = true;
      const { page, itemsPerPage } = this.options;
      let pageNumber = "";
      if (itemsPerPage === -1) {
        pageNumber = "";
      } else {
        pageNumber = page ? page : 1;
      }

      const perPage = itemsPerPage < 0 ? "" : itemsPerPage;
      let distributorId = "";
      if (this.$props.isDistributor) {
        distributorId = `&codDistributor=${this.$props.distributorId}`;
      }
      await this.$api
        .get(
          `/online/cod/list?status=ACTIVATED&page=${pageNumber}&limit=${perPage}&query=${searchVal}${distributorId}`
        )
        .then((response) => {
          const newArr = response.data.data;
          newArr.subscribers.map((obj) => {
            obj.customer = obj.firstName + " " + obj.lastName;
          });
          // this.table.data = newArr.subscribers.sort(function(a, b) {
          //   return b["count"] - a["count"];
          // });
          this.table.data = newArr.subscribers;
          this.table.total = newArr.total;
          this.table.numberOfPages = Math.ceil(newArr.total / itemsPerPage);
          this.exportExcel(newArr.subscribers);
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    duration(start, end) {
      // console.log(start, end);
      const date1 = moment(new Date(start)).format("YYYY-DD-MM"); //todays date
      const date2 = moment(new Date(end)).format("YYYY-DD-MM"); // another date

      const newDate1 = moment(date1, "YYYY-DD-MM", true);
      const newDate2 = moment(date2, "YYYY-DD-MM", true);
      let totalDays = newDate2.diff(newDate1, "days");
      return `${totalDays} ${totalDays > 1 ? "days" : "day"}`;
    },

    getTotal(data) {
      return data.reduce((partialSum, a) => partialSum + a.count, 0);
    },

    async showDetails(item) {
      await this.$refs.onlineAppDialog.open(item, "installed").then((response) => {
        if (response) {
          // this.table.selected = [];
          this.getList();
        }
      });
    },

    exportExcel(items) {
      let exportData = items.map((item) => {
        return {
          Customer: item.customer,
          Distributor: item?.codDistributor.name,
          "Rereference Number": item.referenceNumber,
          "Mobile Number": item.mobileNumber,
          "Affiliator Name":
            item.affiliate && Object.keys(item.affiliate).length !== 0
              ? `${item.affiliate.firstname} ${item.affiliate.lastname}`
              : "",
          "Affiliator Number":
            item.affiliate && Object.keys(item.affiliate).length !== 0
              ? item.affiliate.msisdn
              : "",
          Address: `${item.address} ${item.village}, ${item.barangay}, ${item.city}, ${item.province}, ${item.region}`,
          Barangay: item.barangay,
          City: item.city,
          Province: item.province,
          Region: item.region,
          "Date Applied": this.formatDate(item.createdDate, "MMM DD, YYYY hh:ss A"),
          "Preferred Date/Time": this.formatDate(
            item.installationDate,
            "ddd MMM. DD, YYYY HH:ss A"
          ),
          "SKU Name": item.sku?.skuName,
          "SKU Price": item.sku?.price,
          "Next Call Date": item.nextCallDate,
        };
      });
      this.fileName = `COD_INSTALLED`;
      this.exportData = exportData;
    },

    searchRecord() {
      this.options.page = 1;
      if (!this.search) {
        return;
      }

      this.getList(this.search);
    },
  },

  mounted() {
    this.getList();
    // console.log(this.$props.headers);
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },

    options: {
      handler() {
        this.getList(this.search);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.p-0 {
  padding: 0px !important;
}

.sub-areas > div > table > thead > tr {
  background-color: red;
  border-radius: 10px;
}
</style>
